import { useEffect, useMemo, useState } from "react";

import { wfhCountryInfoService } from "./services";

function compare(a, b) {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
}

export const useWfhCountryInfoState = () => {
  const [countryInfo, setCountryInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleGetAllCountryInfoRecords();
  }, []);

  const handleGetAllCountryInfoRecords = async () => {
    setIsLoading(true);

    try {
      const data = await wfhCountryInfoService.getAllCountryInfoRecords();
      setCountryInfo(data);
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  const countryInfoFieldsMapper = (record) => ({
    country: record["Country"] ?? "",
    countryCode: record["Country code"] ?? "",
    allowance: record["WFH Allowance"] ?? "",
    rules: record["WFH Rules"] ?? "",
    inclusiveAllowance: record["Inclusive allowances"] ?? "",
    GDPR: record["Data protection guidelines"] ?? "",
    additionalAllowance: record["Additional allowances"] ?? "",
    taxNotes: record["Tax related information"] ?? "",
  });

  const countryInfoRecords = useMemo(
    () => countryInfo.map(countryInfoFieldsMapper),
    [countryInfo]
  );

  const countryInfoOptions = useMemo(
    () =>
      countryInfoRecords
        .map(({ country, countryCode }) => ({
          value: countryCode,
          label: country,
        }))
        .sort(compare),
    [countryInfoRecords]
  );

  return {
    countryInfoRecords,
    countryInfoOptions,
    isLoading,
  };
};
